<template>
  <div class="bend">
    <b-container fluid style="height: 100%">
      <div class="bendwrapper">
        <div class="bendmenu">
          <span class="debugtitle">DEBUG:</span>
          <span class="debugtext">{{ debug }}</span>
        </div>

        <div class="bendmenu">
          <span class="debugtitle">BOOK_ID:</span>
          <span class="debugtext">{{ book_id }}</span>
        </div>

        <div class="bendmenu">
          <span class="debugtitle">META_ID:</span>
          <span class="debugtext">{{ meta_id }}</span>
        </div>

        <div class="bendmenu">
          <span class="debugtitle">TABINDEX:</span>
          <span class="debugtext">{{ tabindex }}</span>
        </div>

        <div class="bendmenu" @click="doNext(100)">
          {{ subtitle }}
          <div class="bar" :class="homeClass"></div>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
export default {
  computed: {
    tabindex() {
      return this.$store.state.tabIndex;
    },
    homeClass() {
      return this.$store.state.loc === 1 ? "" : "";
    },
    ingClass() {
      return this.$store.state.loc === 2 ? "active" : "";
    },
    compClass() {
      return this.$store.state.loc === 3 ? "active" : "";
    },
    subtitle() {
      return this.$store.state.subtitle;
    },
    debug() {
      return this.$store.state.debug;
    },
    meta_id() {
      return this.$store.state.questionmeta.id;
    },
    book_id() {
      return this.$store.state.questionmeta.book_id;
    },
  },
  data() {
    return {};
  },
  methods: {
    doNext(loc) {
      this.$router
        .push({
          path: "/task4",
          query: { mode: loc },
        })
        .catch(() => {});

      // this.$store.state.loc = loc;
    },
  },
};
</script>


<style lang="scss" scoped>
@import "@/styles/_variables.scss";
.bend {
  height: 50px;
  background-color: white;
}
.bendwrapper {
  .debugtitle {
    color: $point1;
    font-weight: 500;
  }
  .debugtext {
    color: $color5;
    font-weight: 500;
  }

  height: 100%;
  display: flex;

  //   justify-items: center;
  //   align-content: center;
  //   align-items: center;
  .bendmenu {
    display: inline-flex;
    justify-items: center;

    line-height: 50px;
    padding: 0 15px 0 15px;
    margin-right: 45px;
    position: relative;
    height: 100%;
    font-family: $font;
    cursor: pointer;
    .bar {
      position: absolute;
      width: 100%;
      border-bottom: 5px solid $point1;
      left: 0;
      bottom: 0;
      display: none;
    }
    .active {
      display: block;
    }
  }
}
</style>